import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { IcosContainer } from '../container'
import { removeNgTag } from '../../shared/utils/host'

@Component({
  selector: 'icos-footer',
  template: `
    <footer [class]="'icos-footer ' + class" [ngStyle]="{ height: height }">
      <ng-content></ng-content>
    </footer>
  `
})
export class IcosFooter implements OnInit {
  @Input() height: string = '60px'
  @Input() class: string

  constructor(private root: IcosContainer, private el: ElementRef) {}

  ngOnInit(): void {
    console.log('icos Angular: Container Component is discarded, use [Container directive] replace it.')
    this.root.setVertical(true)
    removeNgTag(this.el.nativeElement)
  }
}
